/**
 * Default 1200x630 social share image (headshot card) used for Open Graph /
 * Twitter cards on pages without a page-specific image.
 */
export const defaultOgImage =
  "https://imagedelivery.net/dZMNLiwpNY0_jKeBRDZ4_g/ef483dd6-29df-45a9-8ef8-645791777100/public";

/** Stable JSON-LD @id so every page's Person references the same entity. */
export const personJsonLdId = "https://www.andrewleger.com/#person";

export const andrewIdentity = {
  name: "Andrew Leger",
  url: "https://www.andrewleger.com",
  email: "andrew@andrewleger.com",
  github: "https://github.com/aleger",
  linkedin: "https://www.linkedin.com/in/andrewleger/",
  twitter: "https://twitter.com/andrewleger",
  twitterHandle: "@andrewleger",
  jobTitle: "Engineering Leader & AI Systems Architect",
  homeLocation: {
    "@type": "Place",
    name: "Omaha, Nebraska, United States",
  },
  alumniOf: ["Western Governors University", "Kirkwood Community College"],
  description:
    "Engineering leader and AI systems architect with 15+ years in tech. Building AI-powered SaaS products and helping engineering teams integrate AI into delivery workflows.",
  sameAs: [
    "https://twitter.com/andrewleger",
    "https://www.linkedin.com/in/andrewleger/",
    "https://github.com/aleger",
  ],
  knowsAbout: [
    "AI Systems Architecture",
    "AI Strategy",
    "Machine Learning Operations",
    "AI Agent Orchestration",
    "LLM Integration",
    "Web Development",
    "Mobile Development",
    "Engineering Management",
    "Product Management",
    "Agile Methodologies",
    "UX/UI Design",
    "Healthcare software",
    "EMS systems",
    "SaaS product development",
  ],
} as const;
